module.exports = __webpack_public_path__ + "files/9a7e4d9e87b489ed28b63bb6c787e93a.png";


//////////////////
// WEBPACK FOOTER
// ./images/app-store-button.png
// module id = 2752
// module chunks = 12